type Timed = {
  total_time_minutes: number | null;
  prep_time_minutes: number | null;
  cook_time_minutes: number | null;
};

/** How long a dinner takes, split where the card splits it.
 *
 * About a quarter of cards give prep and cook separately, and that is the
 * division worth showing: fifteen minutes of chopping before anything can
 * start is a different evening from forty minutes of mostly waiting. The
 * rest print one range, and get one number.
 */
export default function CookingTime({ recipe }: { recipe: Timed }) {
  const { prep_time_minutes: prep, cook_time_minutes: cook } = recipe;
  const total = recipe.total_time_minutes;

  if (prep != null && cook != null) {
    return (
      <span className="cooking-time" title={`${total ?? prep + cook} minutes in total`}>
        <span className="cooking-time__part">{prep} min prep</span>
        <span className="cooking-time__sep"> · </span>
        <span className="cooking-time__part">{cook} min cook</span>
      </span>
    );
  }

  if (total == null) return null;
  return <span className="cooking-time">{total} min</span>;
}
